<template>
  <div id="webinars">
    <rawlplug-webinars></rawlplug-webinars>
  </div>
</template>

<script>
  export default {
    name: "App"
  }
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400;500;700&display=swap');
  @import "~@rawlplug/rawlplug-design-style-framework";
  @import "~@rawlplug/rawlplug-design-style-framework/src/scss/grid-system";

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .rawlplug-webinars {
    font-family: $font-family-rwl-base;
  }
</style>
